"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shadowByIndex = function (index) {
    var elevation = index;
    if (elevation === 0)
        return 'none';
    var percentage = elevation / 24;
    var firstY = 1;
    var firstRadius = 2;
    var firstSpread = -1;
    var secondY = Math.ceil(percentage * 30);
    var secondRadius = Math.ceil(percentage * 60);
    var secondSpread = Math.ceil(percentage * -20);
    var thirdY = Math.ceil(percentage * 9);
    var thirdRadius = Math.ceil(percentage * 46);
    var thirdSpread = Math.ceil(percentage * -22);
    var first = "0px " + firstY + "px " + firstRadius + "px " + firstSpread + "px rgba(0,0,0,0.1)";
    var second = "0px " + secondY + "px " + secondRadius + "px " + secondSpread + "px rgba(0,0,0,0.1)";
    var third = "0px " + thirdY + "px " + thirdRadius + "px " + thirdSpread + "px rgba(0,0,0,0.05)";
    return [first, second, third].join(',');
};
exports.default = Array.from(new Array(25)).map(function (_, index) { return shadowByIndex(index); });
//# sourceMappingURL=ThemeShadows.js.map